export const contaReceberModais = {
  visualizarContaReceber: 'visualizarContaReceber',
  editarContaReceber: 'editarContaReceber',
  importarContaReceber: 'importarContaReceber',
  resgatarContaReceber: 'resgatarContaReceber',
  resgatarContaReceberContrato: 'resgatarContaReceberContrato',
  baixarContaReceber: 'baixarContaReceber',
  buscaAvancada: 'buscaAvancada',
  indicadores: 'indicadores',
  historicoRemessa: 'historicoRemessa',
  arquivoRetorno: 'arquivoRetorno',
  errosPartnerBank: 'errosPartnerBank',
};
